var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sales-statistics flex-column mb-2 pb-2" }, [
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "d-flex p-0 align-items-start" }, [
        _c("span", { staticClass: "statistics-heading" }, [
          _vm._v(
            "\n        Statistics for " +
              _vm._s(_vm.meta.total) +
              " Sales representatives\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex-column" }, [
      _c("div", { staticClass: "d-flex" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-wrap p-0 col-11" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex col-12 p-0" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.total_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.total_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.phone_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.phone_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.website_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.website_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.yelp_chat_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.yelp_chat_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.no_availability_all) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.no_availability_website) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-1 p-0 d-flex justify-content-start category-value"
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.sums.mod_jobs) + "\n          "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-3 p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-4 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.conversion_total) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-4 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.conversion_phone) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-4 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.sums.conversion_website) +
                      "\n            "
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex col-12 p-0" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.total_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.total_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.phone_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.phone_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.website_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.website_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.yelp_chat_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.yelp_chat_leads) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-even p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.no_availability_all) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-6 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.no_availability_website) +
                      "\n            "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-1 p-0 d-flex justify-content-start category-value"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.averages.mod_jobs) +
                    "\n          "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-3 p-0 d-flex justify-content-start category-value"
              },
              [
                _c("div", { staticClass: "category-value col-4 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.conversion_total) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-4 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.conversion_phone) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category-value col-4 p-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.averages.conversion_website) +
                      "\n            "
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex p-0 col-1" }, [
      _c("span", { staticClass: "statistics-heading" }, [_c("span")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex col-12 p-0 text-uppercase text-center" },
      [
        _c(
          "div",
          {
            staticClass: "col-1 p-0 d-flex justify-content-end category-value"
          },
          [_c("span")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-heading flex-even p-0" }, [
          _vm._v("\n            Total\n          ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-heading flex-even p-0" }, [
          _vm._v("\n            Phone\n          ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-heading flex-even p-0" }, [
          _vm._v("\n            Website\n          ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-heading flex-even p-0" }, [
          _vm._v("\n            Yelp Chat\n          ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-heading flex-even p-0" }, [
          _vm._v("\n            No Availability\n          ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-heading col-1 p-0" }, [
          _vm._v("\n            Mod24\n          ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-heading col-3 p-0" }, [
          _vm._v("\n            Conversion\n          ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex col-12 p-0" }, [
      _c(
        "div",
        { staticClass: "col-1 p-0 d-flex justify-content-end category-value" },
        [_c("span")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-even p-0 d-flex justify-content-start category-value"
        },
        [
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Books\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Leads\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-even p-0 d-flex justify-content-start category-value"
        },
        [
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Books\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Leads\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-even p-0 d-flex justify-content-start category-value"
        },
        [
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Books\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Leads\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-even p-0 d-flex justify-content-start category-value"
        },
        [
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Books\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Leads\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-even p-0 d-flex justify-content-start category-value"
        },
        [
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              All\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-value col-6 p-0" }, [
            _vm._v("\n              Website\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-1 p-0 d-flex justify-content-start category-value"
        },
        [_vm._v("\n            Books\n          ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-3 p-0 d-flex justify-content-start category-value"
        },
        [
          _c("div", { staticClass: "category-value col-4 p-0" }, [
            _vm._v("\n              Total\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-value col-4 p-0" }, [
            _vm._v("\n              Phone\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-value col-4 p-0" }, [
            _vm._v("\n              Website\n            ")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-1 p-0 d-flex justify-content-end category-value" },
      [
        _c("span", { staticClass: "text-left pr-4" }, [
          _vm._v("\n              Total\n            ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-1 p-0 d-flex justify-content-end category-value" },
      [
        _c("span", { staticClass: "text-left pr-4" }, [
          _vm._v("\n              Average\n            ")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5403566a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5403566a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/sales/SalesTotalsStatistics.vue
// module id = null
// module chunks = 